import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, KeyRound, ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import OfferGrid from '../components/OfferGrid';
import FeOffer from '../components/FeOffer';

export default function Pricing() {
  const navigate = useNavigate();

  return (
    <div className="App min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="mx-auto max-w-7xl px-5 pb-24 pt-32 md:px-8" data-testid="pricing-page">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-medium uppercase tracking-widest text-node-style">Pricing</p>
          <h1 className="mt-3 font-serif-display text-4xl leading-[1.05] text-white sm:text-5xl md:text-6xl">
            Own the engine. Pay once.
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-muted-foreground">
            Idolaris is a one-time license, not a subscription. Bring your own AI keys and there are <span className="text-white">no monthly fees</span>. You only ever pay the AI providers, at cost.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-node-environment/30 bg-node-environment/10 px-4 py-2 text-sm text-node-environment">
            <KeyRound size={15} /> BYOK &middot; Bring your own AI provider key &mdash; we show you which and how inside, takes 2 minutes
          </div>
        </div>

        {/* Main product */}
        <div className="mt-14"><FeOffer /></div>

        {/* Optional upgrades: each opens its own sub-landing */}
        <div className="mt-20">
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-sm font-medium uppercase tracking-widest text-node-model">Optional upgrades</p>
            <h2 className="mt-3 font-serif-display text-3xl leading-tight text-white sm:text-4xl">Add power as you scale.</h2>
            <p className="mx-auto mt-4 max-w-lg text-sm leading-relaxed text-muted-foreground">These are optional one-time upgrades you can add any time. Open any offer to see the details.</p>
          </div>
          <div className="mt-10"><OfferGrid /></div>
        </div>

        <div className="mx-auto mt-20 max-w-3xl rounded-2xl border border-border bg-card p-8 text-center">
          <h2 className="font-serif-display text-2xl text-white">Not sure yet? Start free.</h2>
          <p className="mx-auto mt-3 max-w-lg text-sm leading-relaxed text-muted-foreground">
            Create an account, set up your first person and generate on us. Upgrade to any license when you&apos;re ready to scale.
          </p>
          <button onClick={() => navigate('/register')} data-testid="pricing-start-free" className="group mt-6 inline-flex h-11 items-center rounded-full bg-white px-6 text-sm font-medium text-black hover:bg-white/90">
            Start creating free <ArrowRight size={15} className="ml-1.5 transition-transform group-hover:translate-x-0.5" />
          </button>
        </div>

        <div className="mx-auto mt-12 grid max-w-4xl gap-4 sm:grid-cols-3">
          {[
            ['No monthly fees', 'A one-time license. Your margins stay yours.'],
            ['You control AI costs', 'Your own keys mean you pay providers directly.'],
            ['Own your data', 'Self-hosted, so nothing leaves your instance.'],
          ].map(([t, d]) => (
            <div key={t} className="rounded-xl border border-border bg-card p-5">
              <Check size={16} className="text-node-environment" />
              <h3 className="mt-3 text-sm font-semibold text-white">{t}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-muted-foreground">{d}</p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
